import { EventConvertHook } from './event.convert.hook'
import { ClientRepresentedEvent, ServerRepresentedEvent } from './event.model'
/**
 * Clears the is virtual parameters
 * @deprecated
 */
export class IsVirtualConvertHook extends EventConvertHook {
  /**
   * stub
   * @param event client event
   * @returns client event
   */
  beforeConvertingToServerRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent {
    return event
  }
  /**
   * clears unused properties
   * @param event server event
   * @returns server event
   * @deprecated
   */
  afterConvertingToServerRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent {
    if (event.is_virtual) {
      event.map_direct_link = ''
      event.venue_address = ''
      event.venue_name = ''
    } else {
      event.virtual_link = ''
    }
    return event
  }
  /**
   * stub
   * @param event server event
   * @returns server event
   */
  beforeConvertingToClientRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent {
    return event
  }
  /**
   * stub
   * @param event client event
   * @returns client event
   */
  afterConvertingToClientRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent {
    return event
  }
}
